import React, { useState } from "react";
import { DialogActions } from "@material-ui/core";
import { TabPanel, TabView } from "primereact/tabview";
import DialogLayout from "../../../../../../partials/content/DialogLayout";
import {
  FormDateField,
  FormTextField,
} from "../../../../../../partials/content/Forms/FormField";
import SearchCustomer from "../../../../sales/customers/searchCustomer";
import SearchLead from "../../../leads/searchLead";
import SearchSalesCard from "../../../slc/searchSalesCard";
import { Card, Badge } from "react-bootstrap";
import { useFormikContext } from "formik";
import { CustomTextAreaField } from "../../../../../../partials/content/Forms";

function VisitEditFormContent(props) {
  const [openSearchVisitTo, setOpenSearchVisitTo] = useState(false);
  const [openSearchSalesCard, setOpenSearchSalesCard] = useState(false);
  const {
    setFieldValue,
    handleBlur,
    handleChange,
    values,
    touched,
    errors,
  } = useFormikContext();
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <Card>
            <Card.Header>
              <i className="fas fa-window-maximize"></i>
              <span>
                <strong>Visit Header</strong>
              </span>
              {values.ID > 0 ? (
                <React.Fragment>
                  <Badge
                    className="float-right ml-1"
                    variant={
                      values.statusID === 1
                        ? "warning"
                        : values.statusID === 2
                        ? "primary"
                        : values.statusID === 3
                        ? "success"
                        : values.statusID === 9
                        ? "danger"
                        : null
                    }
                  >
                    {values.statusID !== 0
                      ? "Visit " + values.statusName
                      : null}
                  </Badge>
                </React.Fragment>
              ) : null}
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <FormTextField
                    label="Visit To"
                    name="visitTo"
                    searchButton
                    onSearchClick={() => {
                      setOpenSearchVisitTo(true);
                    }}
                    readonly
                  />
                  <FormTextField
                    label="Sales Card Name"
                    name="salesCardTitle"
                    searchButton
                    onSearchClick={() => {
                      setOpenSearchSalesCard(true);
                    }}
                    readonly
                  />
                  <FormDateField name="planVisitDate" label="Plan Visit Date" />
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <CustomTextAreaField
                    label="Description"
                    inputType="text"
                    propertyName="description"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    values={values}
                    touched={touched}
                    errors={errors}
                    multiline
                    minRows={7}
                    size="small"
                  />
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
      <DialogLayout
        open={openSearchVisitTo}
        title="Search Visit To"
        onCloseDialog={() => {
          setOpenSearchVisitTo(false);
        }}
        maxWIdth="lg"
      >
        <div className="tabview">
          <div className="card">
            <TabView className="tabview" scrollable>
              <TabPanel header="Customers" rightIcon="fas fa-user-tag">
                <SearchCustomer
                  onSelectCustomer={(customer) => {
                    setFieldValue("customerID", customer.ID);
                    setFieldValue("leadID", 0);
                    setFieldValue("visitTo", customer.customerName);
                    setFieldValue("salesCardID", 0);
                    setFieldValue("salesCardTitle", "");
                    setOpenSearchVisitTo(false);
                  }}
                />
              </TabPanel>
              <TabPanel header="Leads" rightIcon="fas fa-user-check">
                <SearchLead
                  onSelectLead={(lead) => {
                    setFieldValue("leadID", lead.ID);
                    setFieldValue("customerID", 0);
                    setFieldValue(
                      "visitTo",
                      lead.leadName + " " + lead.contactName
                    );

                    setOpenSearchVisitTo(false);
                  }}
                />
              </TabPanel>
            </TabView>
          </div>
        </div>
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchVisitTo(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchSalesCard}
        title="Search Sales Card"
        onCloseDialog={() => {
          setOpenSearchSalesCard(false);
        }}
        maxWIdth="lg"
      >
        <SearchSalesCard
          onSelectSalesCard={(salesCard) => {
            setFieldValue("salesCardID", salesCard.ID);
            setFieldValue("salesCardTitle", salesCard.title);
            if (salesCard.customer.ID > 0) {
              setFieldValue("customerID", salesCard.customer.ID);
              setFieldValue("leadID", 0);
              setFieldValue("visitTo", salesCard.customer.customerName);
            } else if (salesCard.lead.ID > 0) {
              setFieldValue("leadID", salesCard.lead.ID);
              setFieldValue("customerID", 0);
              setFieldValue(
                "visitTo",
                salesCard.lead.leadName + " " + salesCard.lead.contactName
              );
            }
            setOpenSearchSalesCard(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchSalesCard(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default VisitEditFormContent;
